import { memo } from 'react'
import { useRemoteNavigateToPath } from './useRemoteNavigateToPath'

export const RemoteRouteObserver = memo(() => {
  useRemoteNavigateToPath()
  return null
})

RemoteRouteObserver.displayName = 'RemoteRouteObserver'
